
import Vue from 'vue';

Vue.component('folder-options-vue', {
  methods: {
    renameBtn() {
      alert('Rename button clicked'); //Will popup the alert for the fractal
    },
  }
});
